import {getUser} from '@/utils/auth'

export const rules = {
  IS_ADMIN: "is_admin",
  ACCESS_ADMIN_GLOBAL: "can_access_admin_global",
  ACCESS_ESPACE_BENEFICIAIRE: "can_access_espace_beneficiaire",
  ACCESS_ESPACE_GESTION: "can_access_espace_gestion",
  ACCESS_ESPACE_EMPLOYEUR: "can_access_espace_employeur",
  ACCESS_ADMIN_MENU: "can_access_admin_menu",
  ACCESS_SALARIE: "can_access_espace_salarie",
  ACCESS_ESPACE_RC: "can_access_espace_relation_client",
  ACCESS_ESPACE_RPA: "can_access_espace_rpa",
  ACCESS_ADMIN_DROITS: "can_access_admin_droit",
  ACCESS_EDIT_DROIT: "can_edit_droit",
  ACCESS_ADD_DROIT: "can_add_droit",
  ACCESS_ADMIN_BAL: "can_access_admin_bal",
  MANAGE_ADMIN_BAL: "can_manage_admin_bal",
  ACCESS_ADMIN_USERS: "can_access_admin_utilisateur",
  ACCESS_EDIT_USER: "can_edit_user",
  ACCESS_ADD_USER: "can_add_user",
  ACCESS_ADMIN_PROFILES: "can_access_admin_profil",
  ACCESS_EDIT_PROFILE: "can_edit_profile",
  ACCESS_ADD_PROFILE: "can_add_profile",
  ACCESS_ADD_CATEGORY: "can_add_category",
  ACCESS_EDIT_CATEGORY: "can_edit_category",
  ACCESS_ADMIN_STATUS: "can_acces_admin_status",
  ACCESS_ADD_STATUS: "can_add_status",
  ACCESS_EDIT_STATUS: "can_edit_status",
  ACCESS_AEL: "can_access_admin_ael",
  ACCESS_ADMIN_ESPACES: "can_access_admin_espaces",
  ACCESS_EDIT_ESPACE: "can_edit_espace",
  ACCESS_ADD_ESPACE: "can_create_espace",
  ACCESS_ADMIN_MODULES: "can_access_admin_modules",
  ACCESS_EDIT_MODULE: "can_edit_module",
  ACCESS_ADD_MODULE: "can_create_module",
  ACCESS_PARAMETRAGE_TABLE: "can_access_parametrage_table",
  ACCESS_ADMIN_TABLE_TRANSVERSE: "can_configure_table_transverse",
  MANAGE_TABLE_CODE_POSTAL: "can_manage_code_postal",
  MANAGE_TABLE_DELEGATION: "can_manage_delegation_commerciale",
  MANAGE_TABLE_SEGMENT_COMMERCIAL: "can_manage_segment_commercial",
  MANAGE_TABLE_STATUT_PRESTIJ: "can_manage_statut_prestij",
  MANAGE_TRAITEMENT: "can_manage_traitement",
  ACCESS_ADMIN_FIL_OPERATIONS : "can_access_fil_operations",
  CAN_TAKE_PLACE_OF : "can_take_place_of",
  CAN_TAKE_PLACE_OF_TEAM : "can_take_place_of_team",
  CAN_TAKE_PLACE_ALL_SERVICE : "can_take_place_all_service",
  CAN_TAKE_PLACE_ALL_TEAM : "can_take_place_all_team",
  ACCESS_ESPACE_QUALITE: "can_access_espace_qualite",
  ACCESS_ADMIN_MONITORING : "can_access_admin_monitoring",
  ACCESS_ASTUCES : "can_access_astuces",
  MANAGE_ASTUCES : "can_manage_astuces",
  CAN_ACCESS_ADMIN_REPORTS : "can_access_admin_reports",
  CAN_MANAGE_REPORTS : "can_manage_reports",
  CAN_CREATE_REPORT : "can_create_report",
  CAN_EDIT_REPORT : "can_edit_report",
  CAN_DELETE_REPORT : "can_delete_report",
  ACCESS_STRUCTURES : "can_access_admin_structure",
  MANAGE_STRUCTURES : "can_manage_admin_structure",
  MANAGE_OAP_OAG : "can_manage_oap_oag",
  CAN_ACCESS_ESPACE_BIBLIOTHEQUE: "can_access_espace_bibliotheque",
  CAN_ACCESS_LIVRAISONS: "can_access_suivi_livraisons",
  CAN_MANAGE_LIVRAISONS: "can_manage_livraisons",
  CAN_ACCESS_HISTO_LIVRAISONS : 'can_access_histo_livraisons',
  CAN_ACCESS_UPLOAD_FILE_INTERFACE : 'can_access_upload_file_interface',
}

export const espaceBeneficiaireRules = {
  ACCESS_NEWS: 'can_access_eb_news',
  MANAGE_NEWS_FRONT: 'can_manage_eb_news_front',
  MANAGE_NEWS_BO: 'can_manage_eb_news_bo',
  ACCESS_BENEFICIAIRES: 'can_access_eb_beneficiaires',
  ACCESS_ECHEANCIER: 'can_access_eb_echeancier',
  MANAGE_ECHEANCIER: 'can_manage_eb_echeancier',
  ACCESS_FICHE_BENEFICIAIRE: 'can_access_fiche_beneficiaire',
  ACCESS_CONTACTS: 'can_access_eb_contacts',
  ACCESS_FICHE_CONTACT: 'can_access_fiche_contact',
  ACCESS_JUSTIFICATIFS: 'can_access_eb_justificatifs',
  ACCESS_DECOMPTES: 'can_access_eb_decompte',
  ACCESS_STATS: 'can_access_eb_statistiques',
  ACCESS_INSCRIPTIONS: 'can_access_eb_inscriptions',
  ACCESS_CONFIG_SUJETS: 'can_access_eb_config_sujets',
  ACCESS_FAQ: 'can_access_eb_faq',
  MANAGE_FAQ: 'can_manage_eb_faq',
  ACCESS_FICHE_BENEFICIAIRE_JOURNAL: 'can_access_fiche_beneficiaire_journal',
}

export const espaceGestionRules = {
  IS_RESPONSABLE: "is_responsable",
  ACCESS_GESTION_DOSSIER: "can_access_gestion_dossier",
  CAN_MANAGE_SERVICE: "can_manage_service",
  CAN_MANAGE_DOSSIER: "can_manage_dossier",
  CAN_MANAGE_CONSIGNES: "can_manage_consignes",
  CAN_MANAGE_PRODUIT: "can_manage_produits",
  CAN_ACCESS_PRODUIT: "can_access_produits",
  CAN_QUALIFY_DOSSIER: "can_qualify_dossier",
  CAN_AFFECTE_DOSSIER: "can_affecte_dossier",
  CAN_AUTO_AFFECTE: "can_auto_affecte",
  CAN_REOPEN_DOSSIER: "can_reopen_dossier",
  CAN_AFFECTE_DOSSIER_ALL: "can_affecte_dossier_all",
  CAN_CLOSE_ADD_INCIDENT: "can_close_add_incident",
  CAN_ACCESS_DASHBOARD_DOSSIER: "can_access_dashboard_dossier",
  CAN_ACCESS_GESTION_BASKET_DOSSIER: "can_access_gestion_basket_dossier",
  CAN_CREATE_BASKET_DOSSIER: "can_create_basket_dossier",
  CAN_CREATE_BASKET_FOR_ALL_DOSSIER: "can_create_basket_dossier_for_all",
  ACCESS_RECEPTION_MAIL: "can_access_reception_mail",
  ACCESS_STAT_RECEPTION_MAIL: "can_access_stat_reception_mail",
  FORWARD_RECEPTION_MAIL: "can_forward_mail",
  MANAGE_NEUTRALISE_RECEPTION_MAIL: "can_manage_mail_neutralise",
  // ACCESS_PARAMETRAGE_DOSSIER: "can_access_parametrage_dossier",
  CAN_CONFIGURE_DOSSIER: "can_configure_dossier",
  CAN_ACCESS_FICHE_SIREN: "can_access_fiche_siren",
  CAN_MODIFY_FICHE_SIREN: "can_modify_fiche_siren",
  ACCESS_ADMIN_EQUIPES: "can_access_gestion_equipe",
  MANAGE_ADMIN_EQUIPES: "can_manage_equipe",
  CAN_ACCESS_GROUP_SIREN: "can_access_group_siren",
  CAN_MANAGE_GROUP_SIREN: "can_manage_group_siren",
  CAN_ACCESS_JOURNAL_TAB: "can_access_journal_tab",
  CAN_ACCESS_QUALITE_TAB: "can_access_qualite_tab",
  CAN_ACCESS_OBSERVATION_TAB: "can_access_observation_tab",
  CAN_ACCESS_HISTO_TAB: "can_access_histo_sinistre_tab",
  CAN_ACCESS_DECOMPTE_TAB: "can_access_decompte_tab",
  CAN_ACCESS_INCIDENT_TAB: "can_access_incident_tab",
  CAN_ACCESS_BLOCK_HELP: "can_access_block_help",
  CAN_ACCESS_ACTUALITE: "can_access_actualite",
  CAN_MANAGE_ACTUALITE: "can_manage_actualite",
  CAN_DOWNLOAD_GUARDED_FILE: "can_download_guarded_file",
  CAN_ACCESS_EXTRACTIONS: "can_access_extractions",
  CAN_CHANGE_PREFERENCE_SEGMENT_GEST: "can_change_preference_segment_gest",
  CAN_CHANGE_PREFERENCE_DELEGATION: "can_change_preference_delegation",
  CAN_CHANGE_PREFERENCE_SEGMENT_COM: "can_change_preference_segment_com",
  CAN_CHANGE_PREFERENCE_PRESTIJ: "can_change_preference_prestij",
  CAN_CHANGE_PREFERENCE_PRESTIJ_MASSE: "can_change_preference_prestij_en_masse",
  CAN_CHANGE_PREFERENCE_SIRH: "can_change_preference_sirh",
  CAN_CHANGE_PREFERENCE_FORMAT_CEV: "can_change_preference_format_cev",
  CAN_CHANGE_PREFERENCE_SUBROGATION: "can_change_preference_subrogation",
  CAN_CHANGE_PREFERENCE_CEA: "can_change_preference_cea",
  CAN_CHANGE_PREFERENCE_DISPENSE_BS: "can_change_preference_dispense_bs",
  CAN_ACCESS_ASSURES: "can_access_assures",
  CAN_ACCESS_IMPORT_PRESTIJ: "can_access_import_prestij",
  CAN_EXECUTE_CHARGEMENT_FLUX: "can_execute_chargement_flux",
  CAN_MAKE_DPC_CEV: "can_make_dpc_cev",
  CAN_ACCESS_DECOMPTE_IJ: "can_access_decompte_ij",
  CAN_ACCESS_MODULE_PREV: "can_access_module_prev",
  CAN_EXECUTE_CHARGEMENT_PREV: "can_execute_chargement_prev",
  CAN_EXECUTE_OPC_PREV: "can_execute_opc_prev",
  CAN_EXECUTE_DESAFFECTATION_MASSE_OCP: "can_execute_desaffectation_masse_ocp",
  CAN_EXECUTE_RELANCE_DPC: "can_execute_relance_dpc",
  CAN_IMPORT_DBCO_STOCK: "can_import_dbco_stock",
  CAN_ACCESS_DECOMPTE_INVALDC: "can_access_decompte_invaldc",
  CAN_ACCESS_DECOMPTE_INVAL: "can_access_decompte_inval",
  CAN_ACCESS_DECOMPTE_DC: "can_access_decompte_dc",
  CAN_SET_DOSSIER_URGENT: "can_set_dossier_urgent",
  CAN_VALIDATE_DPC: "can_validate_dpc",
  EXTRACT_CONSIGNES_SIREN: "can_extract_consignes_siren",
  EXTRACT_CONSIGNES_NIR: "can_extract_consignes_nir",
  EXTRACT_CONSIGNES_SEGMENT: "can_extract_consignes_segment",
  EXTRACT_CONSIGNES_PRODUITS: "can_extract_consignes_produits",
  EXTRACT_CONSIGNES_BLOCAGES: "can_extract_consignes_blocages",
  CAN_MANAGE_CODE_BARRE_DBCO: "can_manage_code_barre_dbco",
  CAN_MANAGE_LISTING: "can_manage_listing",
  CAN_ACCESS_IMPORT_RENTES: "can_access_import_rentes",
  CAN_SEE_CASE_RECLAMATION: "can_see_case_reclamation",
  CAN_MANAGE_PREFERENCE_DEMATERIALISATION: "can_manage_preference_dematerialisation",
  CAN_DOWNLOAD_DECOMPTE_MUTEX: "can_download_decompte_mutex",
  CAN_MANAGE_CRON_RELANCE_DC: "can_manage_cron_relance_dc",
  CAN_DELETE_PJ_MEDICAL: "can_delete_pj_medical",
  CANT_EDIT_FICHE_DC: "cant_edit_fiche_dc",
}

export const espaceRPARules = {
  ACCESS_SOLDES: 'can_access_soldes',
  ACCESS_MOUVEMENTS: 'can_access_mouvements',
  MANAGE_REF_IBAN_SIREN: 'can_manage_ref_iban_siren',
  MANAGE_RPA_DATA: 'can_manage_rpa_data'
}

export const extractionRules = {
  EXTRACT_DONNES_GENERIQUES: 'can_extract_donnees_generiques',
  EXTRACT_CONTRATS_ACTIFS: 'can_extract_contrats_actifs',
  EXTRACT_UTILISATEURS_CEV: 'can_extract_utilisateurs_cev',
  EXTRACT_EFFECTIFS_SIREN: 'can_extract_effectifs_siren',
  EXTRACT_CODES_POPULATIONS: 'can_extract_codes_populations',
  EXTRACT_MAJ_CODES_PRODUITS: 'can_extract_maj_codes_produits',
  EXTRACT_CODES_PRODUITS: 'can_extract_codes_produits',
  EXTRACT_LIBELLES_POPULATION: 'can_extract_libelles_population',
  EXTRACT_SAISIES_DOSSIERS: 'can_extract_saisies_dossiers',
  EXTRACT_SAISIES_DOSSIERS_RGPD: 'can_extract_saisies_dossiers_rgpd',
  EXTRACT_DOSSIERS_INCIDENT_RGPD: 'can_extract_dossiers_incident_rgpd',
  EXTRACT_DOSSIERS_PRODUIT_STATUS: 'can_extract_dossier_produit_status',
  EXTRACT_DOSSIERS_JOURNAL_STATUS: 'can_extract_dossier_journal_status',
  EXTRACT_DOSSIERS_JOURNAL: 'can_extract_dossier_journal',
  EXTRACT_DOSSIERS_DPC: 'can_extract_dossier_dpc',
  EXTRACT_DOSSIERS_DBCO: 'can_extract_dossier_dbco',
  EXTRACT_AR_COURRIER_DBCO: 'can_extract_ar_courrier_dbco',
  EXTRACT_PORTEFEUILLE_PRODUIT: 'can_extract_portefeuille_produit',
  EXTRACT_PORTEFEUILLE_TAILLE: 'can_extract_portefeuille_taille',
  EXTRACT_PORTEFEUILLE_SIRH: 'can_extract_portefeuille_sirh',
  EXTRACT_ANOMALIES_SIREN_NIC: 'can_extract_anomalies_siren_nic',
  EXTRACT_ANOMALIES_DOUBLON_PM: 'can_extract_anomalies_doublon_pm',
  EXTRACT_ANOMALIES_SOUSCRIPTEURS_MULTIPLES: 'can_extract_anomalies_souscripteurs_multiples',
  EXTRACT_ANOMALIES_PRODUITS: 'can_extract_anomalies_produits',
  EXTRACT_ANOMALIES_CODES_POPULATIONS: 'can_extract_anomalies_codes_populations',
  EXTRACT_BASE_AFFILIATION: 'can_extract_base_affiliation',
  EXTRACT_DECLARATION_AT_CEV: 'can_extract_declaration_at_cev',
  EXTRACT_DECOMPTES: 'can_extract_decomptes',
  EXTRACT_USER_ATLAS: 'can_extract_user_atlas',
  EXTRACT_CHARGEMENT_BPIJ: 'can_extract_chargement_bpij',
  EXTRACT_DOSSIER_REOPEN: 'can_extract_dossier_reopen',
  EXTRACT_FICHE_TEL_DGPO: 'can_extract_fiche_tel_dgpo',
  EXTRACT_DOSSIER_JA_N_1: 'can_extract_dossier_ja_n_1',
  EXTRACT_DOSSIER_INVAL_RESOURCE: 'can_extract_dossier_inval_ressource',
  EXTRACT_STOCK_DOSSIERS: 'can_extract_stock_dossiers',
  EXTRACT_DOSSIERS_TRAITES: 'can_extract_dossiers_traites',
}

export const espaceQualiteRules = {
  ACCESS_CAMPAGNES: 'can_access_campagnes',
  MANAGE_CONTROLE_QUALITE: 'can_manage_controle_qualite'
}

export const espaceBibliothequeRules = {
  CAN_ACCESS_BIBLIOTHEQUE: "can_access_bibliotheque",
  CAN_MANAGE_BIBLIOTHEQUE: "can_manage_bibliotheque",
  CAN_CREATE_DOCUMENT: "can_create_document",
  CAN_EDIT_DOCUMENT: "can_edit_document",
  CAN_DELETE_DOCUMENT: "can_delete_document",
  CAN_ARCHIVE_DOCUMENT: "can_archive_document",
  CAN_MANAGE_BIBLIOTHEQUE_TABLES: "can_manage_bibliotheque_tables",
  CAN_MANAGE_CATEGORIE: "can_manage_categorie_document",
  CAN_MANAGE_TYPE: "can_manage_type_document",
  CAN_MANAGE_RUBRIQUE: "can_manage_rubrique",
  CAN_ACCESS_EPARGNE_RETRAITE: "can_access_epargne_retraite",
}

export const espaceEmployeurRules = {
  CAN_MANAGE_AFFECTATION_GRILLE: "can_manage_affectation_grille_cev",
  CAN_MANAGE_INSCRIPTION: "can_manage_inscription_cev",
  CAN_CHANGE_ADMINISTRATEUR_EMAIL: "can_change_administrateur_email_cev",
  CAN_CHANGE_RAISON_SOCIALE: "can_change_raison_sociale_cev",
  CAN_ACCESS_PRODUIT_DEDIE_INSCRIPTION: "can_access_produit_dedie_inscription_cev",
}

export const espaceRCRules = {
  CAN_MANAGE_FICHES_NIV2: "can_manage_fiche_niv2",
  CAN_MANAGE_DOMAINE_EQUIPE: "can_manage_domaine_equipe",
  CAN_AFFECTE_FICHE: "can_affecte_fiche",
  CAN_VALIDATE_FICHE: "can_validate_fiche",
  CAN_CLOTURE_FICHE_MASSE: "can_cloture_fiche_masse",
}

export const sites = {
  EB: "EB",
  EEM: "EEM",
  ESAL: "ESAL",
  EG: "EG",
  RPA: "RPA",
  SETTINGS: "SETTINGS",
  EC: "EC",
  EBIBLIO: "EBIBLIO",
  ERC: "ERC"
}

export function hasRule(rule) {
  let user = getUser()
  let hasRule = false
  if (user.userProfil !== undefined && user.userProfil.droits !== undefined) {
    let rules = user.userProfil.droits
    for (let index in rules) {
      if (rules[index].libelle_technique === rule){
        hasRule = true
      }
    }
  }
  return hasRule
}

export function hasProfil(profil) {
  let user = getUser()
  let hasProfil = false
  if (user.userProfil !== undefined && user.userProfil.libelle === profil) {
    hasProfil = true
  }
  return hasProfil
}
